const state = {
  // 主题色
  themeColor: '#00b1c3',
  // 主题切换的值
  theme: {
    top: '#00b1c3',
    bottom: '#006d9a'
  }
}

const mutations = {
  // 主题换肤的set方法
  setThemeColor: (state, themeColor) => {
    state.themeColor = themeColor
  },
  setTheme(state, theme) {
    state.theme = theme
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}